import { Stack, Typography } from "@mui/material";

import {
  HubHookFormInput,
  HubHookFormSelect,
  HubHookFormSwitch,
} from "../../components";

const types = {
  select: HubHookFormSelect,
  input: HubHookFormInput,
  checkbox: HubHookFormSwitch,
};

const ItemsTableRow = ({
  label = "",
  name = "",
  fieldType = "input",
  ...rest
}) => {
  const HubHookFormField = types[fieldType] || types.input;

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="caption" className="ItemCell-root">
          {label}
        </Typography>
      </Stack>
      <HubHookFormField
        name={name}
        shouldUnregister={false}
        hideLabel
        {...rest}
      />
    </>
  );
};

export default ItemsTableRow;
